export default __webpack_public_path__ + "static/media/votuza_animate.e53adbe2.gif";